import { clsx } from 'clsx';

import { ReactNode } from 'react';

import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const AnimatedLabel = ({
  inputValue,
  children,
  id,
  className,
}: {
  children: ReactNode;
  inputValue: InputProps['value'];
  id: InputProps['id'];
  className?: string;
}) => (
  <label
    className={clsx(
      className,
      `pl-3.5 transition-all absolute left-0 group-hover:top-2 peer-focus:top-2 peer-focus:text-sm group-hover:text-sm text-shadowy-500 duration-200 delay-100`,
      inputValue ? `top-2 text-sm` : `top-5 text-xl`
    )}
    htmlFor={String(id)}
    data-testid='animated-label'
  >
    {children}
  </label>
);
